import PropTypes from 'prop-types';
import React from 'react';
import LoginForm from '../components/login_form.jsx';
import Loading from '../components/loader.jsx';
import Eula from '../components/eula.jsx';
import { getUser, getCSRF, signEula, login } from '../actions/login';
import { getCustomer } from 'actions/customer';
import connect from '../components/connect';
import { createLoader } from '../loader';
import { pageView } from '../actions/analytics';

import { CSRFResource, userResource } from '../resources/current_user.js';

const extraSlashes = /\/\/+/;
function convertRoutePath(routes) {
    return routes
        .map(r => r.path)
        .join('/')
        .replace(extraSlashes, '/');
}

class Login extends React.Component {
    static displayName = 'Login';

    static propTypes = {
        children: PropTypes.object,
        params: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        isLoggedIn: PropTypes.bool.isRequired,
        eulaRequired: PropTypes.bool.isRequired,
        getUser: PropTypes.func.isRequired,
        getCSRF: PropTypes.func.isRequired,
        signEula: PropTypes.func.isRequired,
        login: PropTypes.func.isRequired,
        routes: PropTypes.arrayOf(
            PropTypes.shape({
                path: PropTypes.string,
            })
        ),
        pageView: PropTypes.func.isRequired,
        getCustomer: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.pageView(convertRoutePath(this.props.routes));
        this.props.getCustomer();
    }

    componentDidUpdate(prevProps, prevState) {
        const lastPath = convertRoutePath(prevProps.routes);
        const nextPath = convertRoutePath(this.props.routes);

        if (nextPath != lastPath) {
            this.props.pageView(nextPath);
        }
    }

    render() {
        if (this.props.isLoggedIn) {
            if (this.props.eulaRequired) {
                return (
                    <div className="app-wrapper">
                        <div className="main" role="main">
                            <Eula signEula={this.props.signEula} />
                        </div>
                    </div>
                );
            }
            return this.props.children;
        }

        return (
            <div className="app-wrapper">
                <div className="main" role="main">
                    <LoginForm login={this.props.login} />
                </div>
            </div>
        );
    }
}

const LoginLoader = createLoader({
    component: Login,

    busy: function LoadingWrapper() {
        return (
            <div className="app-wrapper">
                <div className="main" role="main">
                    <Loading />
                </div>
            </div>
        );
    },

    resources: {
        CSRFResource,
        user: {
            // If the user is offline this just helps by letting the csrf
            // request fail first
            depends: ['CSRFResource'],
            user: userResource,
        },
        isLoggedIn: {
            depends: ['user'],
            isLoggedIn(options, user) {
                return () => user.resource_uri != null;
            },
        },
        eulaRequired: {
            depends: ['user'],
            eulaRequired(options, user) {
                return () => user.eula != null && user.eula.required;
            },
        },
    },
});

function mapStateToProps(state, props) {
    return {
        rootState: state,
    };
}

export default connect(
    mapStateToProps,
    {
        getUser,
        getCSRF,
        signEula,
        login,
        pageView,
        getCustomer,
    }
)(LoginLoader);



// WEBPACK FOOTER //
// ./src/controllerviews/login.jsx